import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InventoryTypeDetail'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InventoryTypeDetailStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryTypeDetailStore",
			variables: true,
		})
	}
}

export async function load_InventoryTypeDetail(params) {
  await initClient()

	const store = new InventoryTypeDetailStore()

	await store.fetch(params)

	return {
		InventoryTypeDetail: store,
	}
}
